import * as types from "./mutation-types";
import { plano_empty } from "./getters";
import _ from "lodash";

export default {
  [types.SET_planoS](state, payload) {
    state.planos = payload;
  },
  [types.SET_plano](state, payload) {
    payload = _.merge(plano_empty(), payload);
    state.plano = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
